import React from 'react';
import { render } from 'react-dom';
import MagazineList from './apps/MagazineList/MagazineList';

// Events List Application
const magazineList = document.getElementById('magazine-app');
if (magazineList)
  render(<MagazineList {...magazineList.dataset} />, magazineList);
